import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import styles from './WrapperContentGemTeam.styles.m.css';

interface IWrapperContentProps {
  classNameContainer?: string;
}

export const WrapperContentGemTeam: FC<PropsWithChildren<IWrapperContentProps>> = ({
  children,
  classNameContainer,
}) => {
  return <div className={classNames(styles.container, classNameContainer)}>{children}</div>;
};
